<div class='UploadConfirmationDialog'>
  <div
    class='UploadConfirmationDialog__spinner {{uploadInProgress ? "d-flex" : "d-none"}} justify-content-center align-items-center flex-column'>
    <div class='alert alert-warning'>
      <p>Your move contacts request is currently being processed. Please wait.</p>
    </div>
    <mat-progress-spinner color='accent' mode='indeterminate'></mat-progress-spinner>
  </div>
  <div *ngIf='items && items.length' [class.hidden]='uploadInProgress' class='UploadConfirmationDialog'>
    <app-table [columns]='tableColumns' [dataSourceParams]='dataSourceParams' [dataSource]='dataSource'></app-table>
  </div>
</div>